<template>
  <div>All Projects</div>
</template>

<script>
  /* eslint-disable no-console */
  import { 
    ATTACH_MEDIA_TO_PROJECT, 
    REMOVE_MEDIA_FROM_PROJECT
  } from '../../../core/config/endpoints/project-media';
  import { postCall } from '../../../core/services/http.service';

  export default {
    name: 'CancelledProjects',
    components: {},
    data() {
      return {};
    },
    methods: {
      attachMediaToProject(projectId, attachments) {
        this.$store.commit('setIsLoaded', true);
        postCall(ATTACH_MEDIA_TO_PROJECT, { project_id: projectId, attachments: attachments })
          .then((response) => {
            console.log(response);
          })
          .catch((error) => {
            this.$toast.error(`${error.response.data.message}`);
          })
          .finally(() => {
            this.$store.commit('setIsLoaded', false);
          });
      },

      removeMediaFromProject(projectId, attachmentsIds) {
        this.$store.commit('setIsLoaded', true);
        postCall(REMOVE_MEDIA_FROM_PROJECT, {
          project_id: 55,
          attachment_ids: [...attachmentsIds],
        })
          .then((response) => {
            console.log(response);
          })
          .catch((error) => {
            this.$toast.error(`${error.response.data.message}`);
          })
          .finally(() => {
            this.$store.commit('setIsLoaded', false);
          });
      },
    },
  };
</script>

<style></style>
